//==============================
// Scroll to Anchor
//==============================

var animationDuration = 800;
var timeoutDuration = 100;

// on page load
var urlHash = window.location.hash;
var urlTarget = urlHash.replace('#', '');
$(document).ready(function() {
  var headerHeight = $('.header').height();
  if (urlHash) {
    var getPos = $('[data-scroll-target="'+urlTarget+'"]').offset().top;
    setTimeout(function() {
      $('html, body').animate({ scrollTop: getPos - headerHeight}, 500);
    }, timeoutDuration);
  }
});

// on click
$('a[href*="#"]:not([href="#"])').click(function() {

  var windowPathname = '//' + window.location.host + window.location.pathname;
  var windowPathnameHttp = 'http://' + window.location.host + window.location.pathname;
  var windowPathnameHttps = 'https://' + window.location.host + window.location.pathname;
  var thisPathname = $(this).attr('href').split('#')[0];
  var thisPathnameHome = thisPathname + '/';
  var headerHeight = $('.header').height();
  // console.log(windowPathname, thisPathname, thisPathnameHome);

  $('.header-nav-button').removeClass('open');
  $('.header-nav').removeClass('open');

  if (
    windowPathname === thisPathname ||
    windowPathnameHttp === thisPathname ||
    windowPathnameHttps === thisPathname ||
    windowPathname === thisPathnameHome ||
    windowPathnameHttp === thisPathnameHome ||
    windowPathnameHttps === thisPathnameHome
  ) {
    var thisHash = $(this).attr('href').split('#')[1];
    var hashElement = $('[data-scroll-target="'+thisHash+'"]');
    var linkPos = hashElement.offset().top;

    setTimeout(function() {
      $('html, body').animate({ scrollTop: linkPos - headerHeight}, animationDuration, function() {
        hashElement.attr('tabindex', '0').focus();
        $('html, body').scrollTop(linkPos - headerHeight);
      });
    }, timeoutDuration);

    return false;
  }
  else {
    var getLocAnchor = $(this).attr('href').replace('#','');
    var anchorElement = $('[data-scroll-target="'+getLocAnchor+'"]');
    var getPosAnchor = anchorElement.offset().top;
    setTimeout(function() {
      $('html, body').animate({ scrollTop: getPosAnchor - headerHeight}, animationDuration, function() {
        anchorElement.attr('tabindex', '0').focus();
        $('html, body').scrollTop(getPosAnchor - headerHeight);
      });
    }, timeoutDuration);
    return false;
  }

});
